import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class PlanningDashboardBalanceViewController extends Controller {
  @service roadmap;

  get scenario() {
    return this.roadmap.scenario;
  }
}
